module.exports = __webpack_public_path__ + "static/14-84eedc99c73bf0bd59718ecee2326c70.png";